
















































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { AuthApi } from "@/core/auth";
import VueRecaptcha from "vue-recaptcha";

declare type TokenType = "reset" | "register" | "confirmed";

@Component({
components: {
	VueRecaptcha,
}})
export default class Mail extends Vue {

	private get Rules(): { [name: string]: (v: string) => true | string } {
		return {
			required: v => !!v || this.$tc("auth_rule_required"),
			min: v => v.length >= 8 || "Min 8 characters",
			passwordMatch: v => v === this.password || this.$tc("auth_rule_passwordMatch"),
			passwordComplexity: v => this.Type === "reset" || (v
				&& v.length >= 8
				&& (  (Mail.PASSWORD_REGEX_LOWERCASE.test(v) ? 1 : 0)
					+ (Mail.PASSWORD_REGEX_UPPERCASE.test(v) ? 1 : 0)
					+ (Mail.PASSWORD_REGEX_NUMBER.test(v) ? 1 : 0)
					+ (Mail.PASSWORD_REGEX_SPECIAL.test(v) ? 1 : 0)
					) >= 3
				) || this.$tc("auth_rule_passwordComplexity"),
		};
	}

	private static readonly PASSWORD_REGEX_LOWERCASE = /[a-zöäü]/;
	private static readonly PASSWORD_REGEX_UPPERCASE = /[A-ZÖÄÜ]/;
	private static readonly PASSWORD_REGEX_NUMBER = /[0-9]/;
	private static readonly PASSWORD_REGEX_SPECIAL = /[\!\"\§\$\%\&\/\(\)\=\?\ß\#\@\µ\-\.\,\+\*\'\?\\\[\]\{\}\_\€\~]/;

	public UserId: number | null = null;
	public Type: TokenType | null = null;
	public Token: string | null = null;

	public password: string = "";
	public passwordRepeat: string = "";
	public captcha: string | null = null;
	public errors: string[] = [];
	// private readonly recaptchaApiKey = "6Lch08cUAAAAAAxqeNDl6C-q3PK16azf6JrA39Vh";
	private readonly recaptchaApiKey = "6LcgPTUUAAAAANbq_5V4-Wh2pxTy5CUXQ6iFKJwS";
	private auth: AuthApi = new AuthApi();

	constructor() {
		super();
	}

	public mounted() {
		this.UserId = parseInt(this.$route.params.id, 10);
		this.Type = this.$route.params.type as TokenType;
		this.Token = this.$route.params.token;

		if (this.Type === "register")
			this.doConfirm();
	}
	private onRecaptchaVerify(response: string) {
		this.captcha = response || null;
	}
	private onRecaptchaExpired() {
		this.captcha = null;
	}

	private async doReset() {
		if (this.password !== null &&
			this.captcha !== null &&
			this.UserId !== null &&
			this.Token !== null &&
			this.Type !== null) {

			await this.auth.confirmToken({
				u: this.UserId,
				c: this.captcha,
				t: this.Token,
				m: this.Type,
				p: this.password,
			});

			this.Type = "confirmed";
		}
	}
	private async doConfirm() {
		if (this.UserId !== null &&
			this.Token !== null &&
			this.Type !== null) {

			await this.auth.confirmToken({
				u: this.UserId,
				t: this.Token,
				m: this.Type,
			});

			this.Type = "confirmed";
		}
	}
}
